import React, { useEffect, useState } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import CancelIcon from "@material-ui/icons/Cancel";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PuiTooltip from "../elements/PuiTooltip ";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuButton: {
            marginRight: theme.spacing(2),
        },
    })
);

interface DraggbaleListProps {
    // リストを区別ため
    type: string;
    // 対象リスト
    targetList: any[];
    // クリックコールバック関数
    onClick?: any;
    // リスト更新用コールバック関数
    onUpdate?: any;
    // クリック対象
    currentId?: string;
}

export default function DraggableList({ ...props }: DraggbaleListProps) {
    const classes = useStyles();
    const [draggable, setDraggable] = useState<any[]>();

    useEffect(() => {
        setDraggable(props.targetList);
    }, [props.targetList]);

    // 項目削除
    const handleClick = (id: string, index: number) => {
        const element = document.getElementById(`${props.type}-${id}`);
        if (element) element.style.display = "none";

        // リスト更新（項目削除）
        const order = Array.from(draggable || []);
        order.splice(index, 1);
        setDraggable(order);
        if (props.onUpdate) props.onUpdate(props.type, order);
    };

    // 並び替え
    const onDragEnd = (result: any) => {
        // 項目がリスト以外に移動した場合
        if (!result.destination) return;

        // リストの順番を変更
        const reorder = Array.from(draggable || []);
        const [removed] = reorder.splice(result.source.index, 1);
        reorder.splice(result.destination.index, 0, removed);
        // 新しい順番をセット
        setDraggable(reorder);
        // リスト順変更あるか
        if (result.source.index !== result.destination.index) {
            if (props.onUpdate) props.onUpdate(props.type, reorder);
        }
    };

    // リスト項目情報取得
    const selectInfo = (targetId: string) => {
        if (props.onClick) props.onClick(targetId);
    };

    return (
        <>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {draggable &&
                                draggable.map((target, index) => (
                                    <Draggable
                                        key={target.id}
                                        draggableId={String(target.id)}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <AppBar
                                                key={`${props.type}-${target.id}`}
                                                id={`${props.type}-${target.id}`}
                                                position="static"
                                                style={{
                                                    boxShadow: "none",
                                                }}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                ref={provided.innerRef}
                                            >
                                                <Toolbar
                                                    variant="dense"
                                                    style={{
                                                        background:
                                                            props.currentId === target.id
                                                                ? "rgb(85, 85, 85)"
                                                                : "white",
                                                        border: "1px solid black",
                                                        paddingRight: "0",
                                                        paddingLeft: "0",
                                                    }}
                                                >
                                                    <IconButton
                                                        edge="start"
                                                        className={classes.menuButton}
                                                        aria-label="menu"
                                                        disabled={true}
                                                    >
                                                        <MenuIcon
                                                            style={{
                                                                color:
                                                                    props.currentId === target.id
                                                                        ? "white"
                                                                        : "rgb(85, 85, 85)",
                                                                width: "40px",
                                                                height: "40px",
                                                                marginLeft: "5px",
                                                            }}
                                                        />
                                                    </IconButton>
                                                    <Typography
                                                        variant="h6"
                                                        onClick={() => selectInfo(`${target.id}`)}
                                                        style={{
                                                            color:
                                                                props.currentId === target.id
                                                                    ? "white"
                                                                    : "black",
                                                            fontSize: "18px",
                                                            marginLeft: "-10px",
                                                            width: "100%",
                                                            height: "56px",
                                                            lineHeight: "3",
                                                            whiteSpace: "nowrap",
                                                            textOverflow: "ellipsis",
                                                            overflow: "hidden",
                                                            fontFamily: "noto-sans-cjk-jp",
                                                        }}
                                                        data-tip={
                                                            target.title
                                                                ? target.title
                                                                : target.fullName
                                                        }
                                                        data-for="title"
                                                    >
                                                        {target.title
                                                            ? target.title
                                                            : target.fullName}
                                                    </Typography>
                                                    <PuiTooltip id="title" />
                                                    <IconButton
                                                        edge="start"
                                                        aria-label="menu"
                                                        onClick={() =>
                                                            handleClick(target.id, index)
                                                        }
                                                    >
                                                        <CancelIcon
                                                            style={{
                                                                color:
                                                                    props.currentId === target.id
                                                                        ? "white"
                                                                        : "gray",
                                                                width: "40px",
                                                                height: "40px",
                                                            }}
                                                        />
                                                    </IconButton>
                                                    {props.currentId === target.id && (
                                                        <ArrowRightIcon
                                                            style={{
                                                                color: "white",
                                                                width: "40px",
                                                                height: "40px",
                                                                position: "absolute",
                                                                right: "-11px",
                                                            }}
                                                        />
                                                    )}
                                                </Toolbar>
                                            </AppBar>
                                        )}
                                    </Draggable>
                                ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    );
}
